"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.list.title': 'Twoje szkolenia',
    'tutorial.list.empty.title': 'Nie Znaleziono Poradników',
    'tutorial.list.empty.message': 'Utwórz swój pierwszy poradnik, aby rozpocząć interaktywne doświadczenia edukacyjne.',
    'tutorial.expired': 'Wygasło',
    'tutorial.draft': 'Szkic',
};
